// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"6e93d719","343":"4eb22efe","824":"c956756e"}[chunkId] + ".chunk.css";
};